/**
 * Resolve an R2 media key to a URL, or return a default placeholder.
 * Keys starting with "avatar:" use DiceBear to generate unique avatars.
 */
export function mediaUrl(key: string | null | undefined, fallback = '/favicon.svg'): string {
  if (!key) return fallback;
  if (key.startsWith('avatar:')) {
    const seed = key.slice(7);
    return `https://api.dicebear.com/9.x/thumbs/svg?seed=${encodeURIComponent(seed)}&backgroundColor=b6e3f4,c0aede,d1d4f9,ffd5dc,ffdfbf`;
  }
  return `/api/media/${key}`;
}
